import React, { useState } from "react";
import { Grid, Button } from "@material-ui/core";
import {
  SERVICE_COVID_19_TEST,
  SERVICE_COVID_19_TEST_NV,
  SERVICE_COVID_19_TEST_KS,
  SERVICE_COVID_19_TEST_MEXICO,
  SERVICE_COVID_19_TEST_ANTIGEN,
  SERVICE_COVID_19_TEST_NV_ANTIGEN,
  SERVICE_COVID_19_TEST_KS_ANTIGEN,
  SERVICE_COVID_19_TEST_MEXICO_ANTIGEN
} from "../../constants";

const DEFAULT_FILTERS = [
  {
    label: "All",
    filterFn: result => result
  },
  {
    label: "PCR Test",
    filterFn: result =>
      (result.services_available || []).some(service =>
        [
          SERVICE_COVID_19_TEST,
          SERVICE_COVID_19_TEST_NV,
          SERVICE_COVID_19_TEST_KS,
          SERVICE_COVID_19_TEST_MEXICO
        ].includes(service.service_code)
      )
  },
  {
    label: "Antigen Test",
    filterFn: result =>
      (result.services_available || []).some(service =>
        [
          SERVICE_COVID_19_TEST_ANTIGEN,
          SERVICE_COVID_19_TEST_NV_ANTIGEN,
          SERVICE_COVID_19_TEST_KS_ANTIGEN,
          SERVICE_COVID_19_TEST_MEXICO_ANTIGEN
        ].includes(service.service_code)
      )
  }
];

const Covid19TestTypeFilters = ({
  options = DEFAULT_FILTERS,
  onChange = () => {}
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleChange = index => {
    setSelectedIndex(index);
    onChange(options[index]);
  };

  return (
    <Grid container spacing={1}>
      {options.map((option, index) => (
        <Grid item key={index}>
          <Button
            size="small"
            variant="contained"
            color={index === selectedIndex ? "primary" : "default"}
            onClick={() => handleChange(index)}
          >
            {option.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export { Covid19TestTypeFilters };
